const PendingBanner = () => {
  return (
    <div className='bg-green-150 dark:bg-gray-900 text-green-900 py-3 flex items-center justify-center gap-2'>
      <span className='font-semibold'>Pending approval!</span>
      <span>ICONIQ is reviewing your request.</span>
    </div>
  );
};

export default PendingBanner;
